
export interface QueueSinkProcessState {
    nodeTag: string;
    configurationName: string;
    scriptName: string;
}
